import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transparencia',
  templateUrl: './transparencia.component.html',
  styleUrls: ['./transparencia.component.css']
})
export class TransparenciaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
